import { useEffect, useContext } from "react";
import { ImContext } from "../Context/DbContext/DbContext";

export const useDbReadyEvent = (callback: () => void) => {
	const im = useContext(ImContext);
	useEffect(() => {
		void im.db.Ready().then(callback);
	}, []);
};
